import { TInvoiceFilter } from "types/TInvoiceFilter";

export const InvoiceFilterDV: TInvoiceFilter = {
  combined_status: [],
  start_date: "",
  end_date: "",
  invoice_number: undefined
};
